import React from "react";
import StackTokenv4Section from "../sections/StackTokenv4Section/Content";
const StackTokenv4Page = () => {
  return <StackTokenv4Section />;
};

export default StackTokenv4Page;
